<template>
  <div>
    <div class="news-card" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
      <span class="jiaobiao" :class="getState(item.clzt)"
        ><font>{{ item.clzt_dictText }}</font></span
      >

      <div class="u-flex-col justify-between" style="height: 100%; flex: 1">
        <div class="justify-between" style="display: flex; align-items: center; margin-bottom: 8px">
          <span class="theme">事件类型：{{ item.sjlx_dictText }}</span>
        </div>
        <span class="theme u-line-4" style="color: #696969">{{ item.bsnr }}</span>

        <div class="justify-between" style="display: flex; align-items: center; margin-top: 8px">
          <span class="dz">{{ item.createTime }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
    // 自定义返回逻辑
    clickItem: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      listData: [],
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.listData = this.list
      },
    },
  },
  created() {},
  methods: {
    goDetail: function (e) {
      if (typeof this.clickItem === 'function') {
        this.clickItem(e.id)
      } else {
        this.$router.push({
          path: '/people/wyfw-view',
          query: { id: e.id },
        })
      }
    },
    getState(state) {
      let stateStr = ''
      if (state == '01') {
        stateStr = 'bg-red'
      } else {
        stateStr = 'bg-green'
      }
      return stateStr
    },
  },
}
</script>

<style lang="less">
.news-card {
  height: auto;
  background: #ffffff;
  display: flex;
  padding: 12px 10px;
  margin: 12px 12px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  position: relative;
  overflow: hidden;

  .title {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .img {
    width: 64px;
    height: 64px;
    margin-right: 10px;
  }

  .theme {
    font-size: 15px;
    font-weight: 400;
    color: #303133;
  }

  .time {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
    margin-top: 10px;
    margin-left: auto;
  }

  .dz {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }
}

.jiaobiao {
  width: 80px;
  height: 80px;
  background: #99adc2;
  color: #fff;
  display: flex;
  align-items: flex-end;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  font-size: 12px;
  top: -40px;
  right: -40px;
  justify-content: center;
}
.jiaobiao font {
  position: relative;
  bottom: 4px;
  letter-spacing: 1px;
}

.bg-red {
  background-color: #fe2424;
}
.bg-yellow {
  background-color: #fea750;
}
.bg-green {
  background-color: #50d27c;
}
</style>
